/*
 * @Author: klcxkjhsm huangshimin@klcxkj.com
 * @Date: 2025-11-17 11:52:12
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2025-11-17 14:23:56
 * @FilePath: \app-client-h5\src\pages\authenticateJumpTip\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import wx from 'weixin-js-sdk';
import { GetRequest } from "../../utils/util";
import { Toast } from 'antd-mobile'
import './index.scss';



class AuthenticateJump extends Component {
    constructor(props) {
        super(props);
        this.state = {
         cx:require("../../assets/cx.jpg")
        };
     
    }

    componentDidMount() {
        document.title = "趣智校园"
       
    }


    render() {
     
        return (
            
            <div style={{marginTop:'1rem',textAlign:'center',lineHeight:'0.4rem'}}>
                <h3>请前往</h3>
                <h2>智慧川信-微服务</h2>
                <h3>完成认证</h3>
                <div>

                    <img style={{width:"50%"}} src={this.state.cx}/>
                </div>
            </div>
        );
    }
}

export default AuthenticateJump;